import api from "./core";

const basePath = "api/core/DoseSpot";

export default {
  isActive() {
    return api.get(`${basePath}/IsActive`);
  },
  getUrlData(patientId) {
    return api.get(`${basePath}/GetClientUrl/${patientId}`);
  }
};
